import { graphql } from 'gatsby';

// Must be separate from other queries, since it can't be sent to Prismic with the preview query
// without causing errors (File is an ImageSharp type, not a Prismic type).
export const ImageSharpFragments = graphql`
    fragment FluidImageFragment on File {
        childImageSharp {
            fluid(maxWidth: 1920, quality: 85) {
                ...GatsbyImageSharpFluid
            }
        }
    }
`;

export const MetaFragment = graphql`
    fragment MetaFragment on PRISMIC__Document {
        _meta {
            uid
            lang
            type
            firstPublicationDate
            lastPublicationDate
            alternateLanguages {
                lang
                uid
                type
                id
            }
        }
    }
`;

export const LinkFragments = graphql`
    fragment ExternalLinkFragment on PRISMIC__ExternalLink {
        _linkType
        url
    }

    fragment InternalLinkFragment on PRISMIC_Page {
        _linkType
        _meta {
            uid
            lang
        }
    }

    fragment FileLinkFragment on PRISMIC__FileLink {
        name
        url
        size
    }

    fragment LinkFragment on PRISMIC__Linkable {
        ...ExternalLinkFragment
        ...InternalLinkFragment
        ...FileLinkFragment
    }
`;

// Single fragment to use in the PricingTab.tsx file.
export const PrismicPricingTabsJsonFragment = graphql`
    fragment PrismicPricingTabsJsonFragment on PrismicPricingTabsJson {
        _meta {
            uid
        }
        id
        frequencies_available
        plans {
            plan {
                name
                api_plan {
                    code
                    description
                    frequencies {
                        interval
                        planProducts {
                            code
                            description
                            maxQuantity
                            name
                            pricingModel
                            quantityRanges {
                                max
                                min
                                prices {
                                    amount
                                    currencyCode
                                    currencySymbol
                                }
                            }
                        }
                        prices {
                            amount
                            currencyCode
                            yearlyDiscount
                            currencySymbol
                            yearlyDiscountPercent
                        }
                    }
                    name
                }
                pricing_cta
                pricing_cta_link {
                    _linkType
                    _meta {
                        lang
                        uid
                    }
                }
                pricing_description {
                    spans {
                        end
                        start
                        type
                    }
                    text
                    type
                }
                products {
                    product {
                        api_product {
                            code
                            description
                            name
                        }
                        discount_text
                        name
                        sub_features {
                            label
                            tooltip
                        }
                        title
                        unlimited_text
                        tooltip {
                            text
                        }
                    }
                }
            }
        }
        name
    }
`;
